var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3","align":"center"}},_vm._l((_vm.items),function(item){return _c('b-tab',{key:item.tab,attrs:{"title":item.tab}},[_c(item.component,{ref:item.component,refInFor:true,tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }